var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 25.414 25.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1259",
    "data-name": "Grupo 1259",
    transform: "translate(-1982.998 -254.998)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_207",
    "data-name": "Elipse 207",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(1983.998 255.998)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_76",
    "data-name": "L\\xEDnea 76",
    x2: 7,
    y2: 7,
    transform: "translate(1999.998 271.998)",
    fill: "none",
    stroke: "#8a8d9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.94a8df572dc45ca7c4788b5669cebce2.svg";
export { ForwardRef as ReactComponent };